var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19507 10.3901H12.1218V9.91392C12.1218 9.27897 11.8043 8.76668 11.1694 8.37705C10.5344 7.98742 9.69746 7.7926 8.65845 7.7926C7.61943 7.7926 6.78245 7.98742 6.1475 8.37705C5.51254 8.76668 5.19507 9.27897 5.19507 9.91392V10.3901ZM8.65845 6.92676C9.13466 6.92676 9.54233 6.7572 9.88145 6.41807C10.2206 6.07895 10.3901 5.67128 10.3901 5.19507C10.3901 4.71885 10.2206 4.31119 9.88145 3.97206C9.54233 3.63294 9.13466 3.46338 8.65845 3.46338C8.18223 3.46338 7.77456 3.63294 7.43544 3.97206C7.09632 4.31119 6.92676 4.71885 6.92676 5.19507C6.92676 5.67128 7.09632 6.07895 7.43544 6.41807C7.77456 6.7572 8.18223 6.92676 8.65845 6.92676ZM0 17.3169V1.73169C0 1.25547 0.169561 0.847806 0.508684 0.508684C0.847806 0.169561 1.25547 0 1.73169 0H15.5852C16.0614 0 16.4691 0.169561 16.8082 0.508684C17.1473 0.847806 17.3169 1.25547 17.3169 1.73169V12.1218C17.3169 12.598 17.1473 13.0057 16.8082 13.3448C16.4691 13.684 16.0614 13.8535 15.5852 13.8535H3.46338L0 17.3169ZM2.72741 12.1218H15.5852V1.73169H1.73169V13.0959L2.72741 12.1218Z",
    fill: "#206021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformar);
export default __webpack_public_path__ + "static/media/informar.47e614e1d38249aa7d69eb2af82ef119.svg";
export { ForwardRef as ReactComponent };